module.exports = __webpack_public_path__ + "img/Silver.bf83e375.png";